/* eslint-disable */
export default {
  logged: 'Registrada',
  unlogged: 'No editada',
  faxNotSupported: 'No se pueden registrar mensajes por fax.',
} as const;

// @key: @#@"logged"@#@ @source: @#@"Logged"@#@
// @key: @#@"unlogged"@#@ @source: @#@"Unworked"@#@
// @key: @#@"faxNotSupported"@#@ @source: @#@"To log fax is not supported."@#@
